import React from 'react';
import { TextInput } from 'react-admin';
import { InputAdornment, IconButton, Tooltip } from '@mui/material';
import { QrCode, Refresh } from '@mui/icons-material';
import { validateManualCode, formatManualCode } from '../../utils/manualCodeValidation';

interface ManualCodeInputProps {
  source?: string;
  label?: string;
  helperText?: string;
  fullWidth?: boolean;
  disabled?: boolean;
}

export const ManualCodeInput: React.FC<ManualCodeInputProps> = ({
  source = 'qrCode',
  label,
  helperText,
  fullWidth = true,
  disabled = false,
}) => {
  const handleFormat = (value: any) => {
    return formatManualCode(value);
  };

  return (
    <TextInput
      source={source}
      label={label}
      validate={validateManualCode}
      format={handleFormat}
      fullWidth={fullWidth}
      disabled={disabled}
      helperText={helperText || 'Leave empty to auto-generate, or enter 4 characters (e.g., A3K9)'}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <QrCode color="action" />
          </InputAdornment>
        ),
        endAdornment: disabled ? null : (
          <InputAdornment position="end">
            <Tooltip title="Leave empty to generate a new code">
              <IconButton size="small" disabled>
                <Refresh fontSize="small" />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
        style: {
          fontFamily: 'monospace',
          fontSize: '1.1rem',
          letterSpacing: '0.2em',
        },
      }}
      inputProps={{
        maxLength: 4,
        style: {
          textTransform: 'uppercase',
        },
        placeholder: 'AUTO',
      }}
    />
  );
};